import React from "react";
import { Text } from "react-native";
import { colors, global } from "../../const";

export default function SubtitleCapBold({ children }) {
    return (
        <Text
            style={{
                fontFamily: global.FONT_BOLD,
                fontSize: 14,
                color: colors.midnightBack,
                fontWeight:"bold",
                textAlign: "center"
            }}
        >
            {children}
        </Text>
    )
}